import { useCallback, useEffect } from 'react';
import {
  LOW_DATA_MODE_SETTING,
  notifyStationSettings,
  writeStationSetting,
} from '../../utils/station/settings';
import { useStationMode } from './useStationMode';
import { useStationSetting } from './useStationSetting';

export const LOW_DATA_MODE_CHANGE_EVENT = 'napster_low_data_mode_change';

/** ?lowdatamode=true) */
export const LOW_DATA_MODE_URL_PARAM = LOW_DATA_MODE_SETTING.param;
const LOW_DATA_MODE_STORAGE_KEY = LOW_DATA_MODE_SETTING.storageKey;

/** low data mode hook */
export function useLowDataMode(): [boolean, (value: boolean) => void] {
  const isStationMode = useStationMode();
  const isLowDataMode = useStationSetting(LOW_DATA_MODE_SETTING);

  // Anything outside this hook that still fires the legacy event keeps working
  useEffect(() => {
    window.addEventListener(LOW_DATA_MODE_CHANGE_EVENT, notifyStationSettings);
    return () =>
      window.removeEventListener(
        LOW_DATA_MODE_CHANGE_EVENT,
        notifyStationSettings,
      );
  }, []);

  const setLowDataMode = useCallback((value: boolean) => {
    if (typeof window === 'undefined') return;
    writeStationSetting(LOW_DATA_MODE_SETTING, value);
    window.dispatchEvent(new CustomEvent(LOW_DATA_MODE_CHANGE_EVENT));
  }, []);

  return [isStationMode && isLowDataMode, setLowDataMode];
}

export { LOW_DATA_MODE_STORAGE_KEY };
